import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import React, { useState } from "react";
import NewConsoleBalanceSheet from "../consoleTabs/newConsoleBalanceSheet";
import NewConsolePnlStatement from "../consoleTabs/newConsolePnlStatement";
import NewConsoleSoccie from "../Socie/newConsoleSoccie";
import AdjustmentConsole from "../Adjustment/adjustment";
import { Tabs, Tab, } from "react-bootstrap";
import ConsoleBalanceNotes from "../consoleTabs/ConsoleBalanceNotes";
import ConsolePnlNotes from "../consoleTabs/ConsolePnlNotes";
import { NewConsoleCashflow } from "../consoleTabs/NewConsoleCashflow";

import commoncss from "../../../myfin_v2/css/common.module.css"
import bookclosuretablecss from "../../../myfin_v2/css/bookclosuretable.module.css";
import tablecss from "../../../myfin_v2/css/table.module.css";
import InterCompanyEliminationsEntries from "../../../myfin_v2/components/console/InterCompanyEliminationEntires";
import ICEWorkings from "../../../myfin_v2/components/console/ICEWorkings";
import PerformReconciliation from "../../../myfin_v2/components/console/PerformReconciliation";
import ViewReconciliation from "../../../myfin_v2/components/console/ViewReconciliation";


function BSModalView(props) {
  const {
    setBSNotesSubmenu,
    activeTab,
    consoleData,
    allcheckdata,
    currentCompProjectId,
    consoleNotes,
    balanceSheetData,
    pnlStatementData,
    groupingData,
    id,
    allAssociateCheckData,
    associateStatement,
    CompanyName,
    FindIr,
  } = props;
  // const [rows, setRows] = useState([]);
  const [currentProfit, setCurrentProfit] = useState("");
  const [currentYearProfit, setCurrentYearProfit] = useState("");
  // const [tab, setTab] = useState("bs");
  const [comProfit, setComProfit] = useState("");
  const [comYearProfit, setComYearProfit] = useState("");
  const [key, setKey] = useState("Balance Sheets");

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  const [value, setValue] = React.useState(0);
  // const [checkFsData, setCheckData] = useState(0);
  const [recentTab, setCurrentTab] = useState("");
  const [tabCheck, setTab] = useState("");
  const [eliminationScreen, setEliminationScreen] = useState(0);


  const eliminationScreens = {
    0: "entries",
    1: "workings",
    2: "performreconciliation",
    3: "viewreconciliation",
  }



  return (
    <div style={{ "padding": "5px 10px" }}>
      {activeTab === 0 && (
        <NewConsoleBalanceSheet
          setTempValue={setValue}
          balanceSheetData={balanceSheetData}
          groupingData={groupingData}
          currentCompany={consoleData}
          // headingData={allcheckdata.map((data) => data[0].company)}
          notes={consoleNotes}
          currentCompProjectId={currentCompProjectId}
          subsiaryData={allcheckdata}
          browsFs={[]}
          setKey={setKey}
          setCurrentTab={setCurrentTab}
          CompanyName={CompanyName}
        />
      )}

      {activeTab === 1 && (

        <NewConsolePnlStatement
          setTempValue={setValue}
          pnlStatementData={pnlStatementData}
          currentCompany={consoleData}
          // headingData={allcheckdata.map((data) => data[0].company)}
          currentCompProjectId={currentCompProjectId}
          subsiaryData={allcheckdata}
          consoleNotes={consoleNotes}
          groupingData={groupingData}
          setCurrentProfit={setCurrentProfit}
          setCurrentYearProfit={setCurrentYearProfit}
          setComYearProfit={setComYearProfit}
          currentProfit={currentProfit}
          setComProfit={setComProfit}
          setTab={setTab}
          setKey={setKey}
          allAssociateCheckData={allAssociateCheckData}
          associateStatement={associateStatement}
          CompanyName={CompanyName}
        />
      )}

      {activeTab === 2 && (

        <NewConsoleSoccie
          allcheckdata={allcheckdata}
          subsiaryData={allcheckdata}
          currentCompProjectId={currentCompProjectId}
          currentProfit={currentProfit}
          comProfit={comProfit}
          currentYearProfit={currentYearProfit}
          comYearProfit={comYearProfit}
          currentCompany={consoleData}
          pnlStatementData={pnlStatementData}
          // headingData={allcheckdata.map((data) => data.company)}
          groupingData={groupingData}
          consoleNotes={consoleNotes}
          CompanyName={CompanyName}
        />
      )}
      {activeTab === 3 && (

        <NewConsoleCashflow
          setTempValue={setValue}
          pnlStatementData={pnlStatementData}
          currentCompany={consoleData}
          currentCompProjectId={currentCompProjectId}
          subsiaryData={allcheckdata}
          consoleNotes={consoleNotes}
          groupingData={groupingData}
          setCurrentProfit={setCurrentProfit}
          setCurrentYearProfit={setCurrentYearProfit}
          setComYearProfit={setComYearProfit}
          currentProfit={currentProfit}
          setComProfit={setComProfit}
          setTab={setTab}
          setKey={setKey}
          allAssociateCheckData={allAssociateCheckData}
          associateStatement={associateStatement}
          CompanyName={CompanyName}
        />
      )}

      {activeTab === 4 && (
        <ConsoleBalanceNotes
          setBSNotesSubmenu={setBSNotesSubmenu}
          consoleNotes={consoleNotes}
          balanceSheetData={balanceSheetData}
          groupingData={groupingData}
          consoleData={consoleData}
          allcheckdata={allcheckdata}
          tab={recentTab}
          pnlStatementData={pnlStatementData}
          currentCompProjectId={currentCompProjectId}
          checkKey={value}
          subsiaryData={allcheckdata}
          id={id}
          FindIr={FindIr}
          CompanyName={CompanyName}
        />
      )}

      {activeTab === 6 && (
        <>
          {eliminationScreens[eliminationScreen] === "entries" && (
            <InterCompanyEliminationsEntries  setEliminationScreen={setEliminationScreen}/>
          )}

          {eliminationScreens[eliminationScreen] === "workings" && (
            <ICEWorkings setEliminationScreen={setEliminationScreen}/>
          )}

          {eliminationScreens[eliminationScreen] === "performreconciliation" && (
            <PerformReconciliation setEliminationScreen={setEliminationScreen}/>
          )}

          {eliminationScreens[eliminationScreen] === "viewreconciliation" && (
            <ViewReconciliation setEliminationScreen={setEliminationScreen}/>
          )}
        </>
      )}

        {/* <Tab eventKey="Notes" title="Balance Sheet Notes">
          <div
            style={{
              minHeight: "100vh",
              backgroundColor: "white",
            }}
          >
            <ConsoleBalanceNotes
              consoleNotes={consoleNotes}
              balanceSheetData={balanceSheetData}
              groupingData={groupingData}
              consoleData={consoleData}
              allcheckdata={allcheckdata}
              tab={recentTab}
              pnlStatementData={pnlStatementData}
              currentCompProjectId={currentCompProjectId}
              checkKey={value}
              subsiaryData={allcheckdata}
              id={id}
              FindIr={FindIr}
              CompanyName={CompanyName}
            />
          </div>
        </Tab>
        <Tab eventKey="Notes2" title="PNL Statement Notes">
          <div
            style={{
              minHeight: "100vh",
              backgroundColor: "white",
            }}
          >
            <ConsolePnlNotes
              pnlStatementData={pnlStatementData}
              consoleData={consoleData}
              currentCompProjectId={currentCompProjectId}
              subsiaryData={allcheckdata}
              consoleNotes={consoleNotes}
              groupingData={groupingData}
              setCurrentProfit={setCurrentProfit}
              setCurrentYearProfit={setCurrentYearProfit}
              setComYearProfit={setComYearProfit}
              currentProfit={currentProfit}
              setComProfit={setComProfit}
              // headingData={headingData}
              allcheckdata={allcheckdata}
              tab={tabCheck}
              checkKey={value}
              CompanyName={CompanyName}
            />
          </div>
        </Tab>
        <Tab eventKey="adjustment" title="adjustment">
          <div
            style={{
              maxHeight: "100%",
              backgroundColor: "white",
            }}
          >
            <AdjustmentConsole
              currentCompany={consoleData}
              subsiaryData={allcheckdata}
              groupingData={groupingData}
              notes={consoleNotes}
              id={id}
            />
          </div>
        </Tab>
      </Tabs> */}
    </div>
  );
}

export default BSModalView;
